import Pause from '@mui/icons-material/Pause';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Replay from '@mui/icons-material/Replay';
import Timer from '@mui/icons-material/Timer';
import { Alert, Button, Snackbar, ThemeProvider, Tooltip, Typography, createTheme } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import '../../css/botao.css';
import ReactComponent from '../ReactComponent';

const TimeTheme = createTheme({
    components: {
        MuiInputBase: { styleOverrides: { root: { height: '30px' }, input: { paddingLeft: '6px !important' } } },
        MuiIconButton: { styleOverrides: { root: { padding: '0px', marginLeft: '-6px' } } },
        MuiDialogActions: { styleOverrides: { root: { justifyContent: 'center' } } }
    }
});

class Cronometro extends ReactComponent {
    inputTempo = dayjs()
        .minute(this.parametroStore.isOrgaoTST ? 10 : 15)
        .second(0);
    edicaoOn = true;
    tempoPassado = 0;
    tempoCorrendo = false;
    snackbarOpen = false;
    snackbarMessage = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            inputTempo: observable,
            edicaoOn: observable,
            tempoPassado: observable,
            tempoCorrendo: observable,
            snackbarOpen: observable,
            snackbarMessage: observable,
            pauseTimer: action,
            inicarTimer: action,
            reset: action,
            onChangeInputTempo: action,
            updateTempoPassado: action,
            updateTempoCorrendo: action,
            stringTimer: computed,
            showSnackbar: action,
            handleCloseSnackbar: action
        });
    }

    get tempoEmSegundos() {
        return this.sessaoStore.cronometro.tempoEmSegundos;
    }

    timer;
    inicioTimer;

    pauseTimer = () => {
        const segTotal = this.tempoEmSegundos - this.tempoPassado;
        this.sessaoService.notificarCronometroPause(this.sessaoStore.idSessaoSelecionada, segTotal);
    };

    inicarTimer = () => {
        if (this.sessaoStore.cronometro.tempoEmSegundos < 1) {
            this.showSnackbar('Valor inválido. O tempo deve ser maior que 00:00');
            return;
        }

        const segTotal = this.tempoEmSegundos - this.tempoPassado;
        this.sessaoService.notificarCronometroStart(this.sessaoStore.idSessaoSelecionada, segTotal);
    };

    componentWillUnmount = () => {
        super.componentWillUnmount();
        clearInterval(this.timer);
    };

    reset = () => {
        this.sessaoService.notificarCronometroParar(this.sessaoStore.idSessaoSelecionada);
    };

    onChangeInputTempo = (newValue) => {
        if (newValue) {
            this.inputTempo = newValue;
            const tempo = newValue.format('mm:ss').split(':');
            const minutos = parseInt(tempo[0], 10) || 0;
            const segundos = parseInt(tempo[1], 10) || 0;
            this.sessaoStore.cronometro.tempoEmSegundos = minutos * 60 + segundos;
        } else {
            this.inputTempo = dayjs()
                .minute(this.parametroStore.isOrgaoTST ? 10 : 15)
                .second(0);
            this.sessaoStore.cronometro.tempoEmSegundos = this.parametroStore.isOrgaoTST ? 600 : 900;
        }
    };

    updateTempoPassado = (tempoPassado) => {
        this.tempoPassado = tempoPassado;
    };

    updateTempoCorrendo = (tempoCorrendo) => {
        this.tempoCorrendo = tempoCorrendo;
    };

    get stringTimer() {
        let seg = this.tempoEmSegundos - this.tempoPassado;
        let min = Math.floor(seg / 60);
        seg = seg % 60;
        return `${min < 10 ? '0' + min : min}:${seg < 10 ? '0' + seg : seg}`;
    }

    reactionCronometroOperacao = reaction(
        () => this.sessaoStore.cronometro.operacao,
        (operacao) => {
            if (operacao.toUpperCase() === 'INICIAR') {
                if (!this.timer) {
                    this.updateTempoPassado(0);
                    this.updateTempoCorrendo(true);
                    this.edicaoOn = false;
                    this.inicioTimer = moment();
                    this.timer = setInterval(() => {
                        this.updateTempoPassado(moment().diff(this.inicioTimer, 'seconds'));

                        if (this.tempoEmSegundos - this.tempoPassado <= 0) {
                            clearInterval(this.timer);
                            this.timer = undefined;
                            this.updateTempoCorrendo(false);
                        }
                    }, 200);
                }
            } else {
                clearInterval(this.timer);
                this.timer = undefined;
                this.updateTempoCorrendo(false);
                if (operacao.toUpperCase() === 'PARAR') {
                    this.updateTempoPassado(0);
                    this.edicaoOn = true;
                    this.inputTempo = dayjs()
                        .minute(this.parametroStore.isOrgaoTST ? 10 : 15)
                        .second(0);
                }
            }
        }
    );

    showSnackbar = (message) => {
        this.snackbarMessage = message;
        this.snackbarOpen = true;
    };

    handleCloseSnackbar = () => {
        this.snackbarOpen = false;
        this.snackbarMessage = '';
    };

    render() {
        let estiloBotaoPlayPause = { padding: '0px', minWidth: '0', color: this.observableProps.cor };
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', margin: '8px' }}>
                    <Timer />
                </div>
                {this.edicaoOn ? (
                    <ThemeProvider theme={TimeTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                                views={['minutes', 'seconds']}
                                timeSteps={{ minutes: 1, seconds: 1 }}
                                format="mm:ss"
                                sx={{
                                    width: '9.5ch',
                                    bgcolor: 'white',
                                    borderRadius: '4px',
                                    '.MuiPickersSectionList-root': { padding: '4px 0' }
                                }}
                                value={this.inputTempo}
                                onChange={this.onChangeInputTempo}
                                slotProps={{ actionBar: { actions: ['accept'] } }}
                            />
                        </LocalizationProvider>
                    </ThemeProvider>
                ) : (
                    <Typography
                        sx={{
                            mr: '6px',
                            color:
                                this.tempoEmSegundos - this.tempoPassado <= 120
                                    ? (this.tempoEmSegundos - this.tempoPassado) % 2 === 0
                                        ? 'red'
                                        : 'white'
                                    : 'white'
                        }}
                    >
                        {this.stringTimer}
                    </Typography>
                )}
                {this.tempoCorrendo ? (
                    <Tooltip title="Pausar cronômetro">
                        <Button
                            onClick={this.pauseTimer}
                            style={estiloBotaoPlayPause}
                            className="corBotaoAmarelo"
                        >
                            <Pause />
                        </Button>
                    </Tooltip>
                ) : (
                    <Tooltip title="Iniciar cronômetro">
                        <Button
                            onClick={this.inicarTimer}
                            style={estiloBotaoPlayPause}
                            className="corBotaoAmarelo"
                        >
                            <PlayArrow />
                        </Button>
                    </Tooltip>
                )}
                {this.tempoEmSegundos - this.tempoPassado !== this.tempoEmSegundos && (
                    <Tooltip title="Resetar cronômetro">
                        <Button
                            onClick={this.reset}
                            sx={estiloBotaoPlayPause}
                            className="corBotaoAmarelo"
                        >
                            <Replay sx={{ ml: '4px' }} />
                        </Button>
                    </Tooltip>
                )}
                <Snackbar
                    open={this.snackbarOpen}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    autoHideDuration={6000}
                    onClose={this.handleCloseSnackbar}
                >
                    <Alert
                        onClose={this.handleCloseSnackbar}
                        variant="filled"
                        severity="error"
                        sx={{ alignItems: 'center' }}
                    >
                        {this.snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}

export default inject('stores')(observer(Cronometro));
